import { ClassBaseService } from './../../services/class-base.service';
import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { MessageComposeComponent } from '../message-compose/message-compose.component';
import { QuillEditorHelperService } from '../shared/quill-editor/quill-editor-helper.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-compose-message-modal',
  templateUrl: './compose-message-modal.component.html',
  styleUrls: ['./compose-message-modal.component.scss']
})
export class ComposeMessageModalComponent extends MessageComposeComponent implements OnInit, OnDestroy {
  minimize: Function;
  hide: Function;
  rerenderGridSubscription: Subscription;
  beforeUnloadUnsubscribe: Function;
  modalId: string;
  header: string;
  _options: any;
  forStudentId: number;
  attachments: number[] = [];
  filesToUpload = [];
  fileCategories = [];
  quillModules: any;
  messageData: any;

  @ViewChild('messageForm') form: NgForm;

  constructor(
    notificationService: NotificationService,
    _commonAuthService: CommonAuthenticationService,
    _commonDataSharedService: CommonDataSharedService,
    _commonRequestResponseService: CommonRequestResponseService,
    _commonService: CommonService,
     _router: Router,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private _classBaseService: ClassBaseService,
    private quillHelper: QuillEditorHelperService
  ) {
    super(notificationService, _commonAuthService, _commonDataSharedService, _commonRequestResponseService, _commonService, _router);
  }

  ngOnInit() {
    this.quillModules = this.quillHelper.getQuillModules();
    this._commonRequestResponseService.post('shared/getattachments/bytoken', {})
      .subscribe((response: any) => {
        if (!response.list || !response.list.length) {
          return;
        }
        const attachments = response.list.filter((attachment: any) => this.attachments.includes(attachment.attachmentID));
        if (!attachments.length) {
          return;
        }
        attachments.forEach((attachment: any, i: number) => {
          attachment.uploaded = true;
          attachment.id = i;
        });
        if (attachments.length < 2) {
          attachments.push({ id: '1', disable: false, upload: false, uploaded: false, attachmentData: {} });
        }
        this.messageFileComponentArray = attachments || this.messageFileComponentArray;
        this.attachmentIdArray = this.attachments.slice(0);
      });
    this.updateFormData();
    this.beforeUnloadUnsubscribe = this.renderer.listen('window', 'beforeunload', () => {
      this.minimize();
      return true;
    });
    this.rerenderGridSubscription = this.renderGrid.subscribe(() => {
      this.hide();
      this.reRenderGrid();
    });
    this.form.valueChanges.subscribe((changes: any) => {
      this._options.initialState.messageData = Object.assign(
        {},
        this._options.initialState.messageData,
        Object.assign(this.messageData, { detail: changes.messageContent, subject: changes.messageTopic }))
    });

    this.fileUploaded.subscribe((fileData: any) => {
      this._options.initialState.attachments.push(fileData);
    });
    if (this._options.class) {
      this.renderer.addClass(this.elRef.nativeElement, this._options.class);
    }
    this.getDocumentCategory();
  }

  deleteFile(id) {
    if (id === null || typeof id === 'undefined') {
      return;
    }
    if (this.uploadFileData) {
      this.uploadFileData.splice(id, 1);
    }
    if (this.attachmentIdArray) {
      this.attachmentIdArray.splice(id, 1);
    }
    const attachmentID = this.messageFileComponentArray[id].attachmentID;
    this._options.initialState.attachments.splice(this.attachments.indexOf(attachmentID), 1);
    this.messageFileComponentArray[id] = { id, disable: false, upload: false, uploaded: false, attachmentData: {} };
  }

  updateFormData() {
    this.defaultArr.push('partnerId');
    this.setUserData();
    this.setMessageDefaultData();
    this.resetFileData();
    this.messageTopic = this.messageData.subject;
    this.messageContent = '';
  }

  reRenderGrid() {
    this._commonDataSharedService.gridReRender.next({
      renderStatus: true,
      from: 'Coach Message'
    });
  }

  uploadFileHandler(e) {
    this._commonService.chooseFileEvent(e[0]).Ok((data: any) => {
      this.filesToUpload.push({
        file: data.fileBytes,
        fileName: data.fileName
      });
    })
  }

  removeFile(i: number) {
    this.filesToUpload.splice(i, 1);
  }

  getDocumentCategory() {
    this._classBaseService.getDocumentTypeList()
      .subscribe(
        (tempCategoryList: any) => {
          this.fileCategories = tempCategoryList;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching document class data');
        });
  }

  changeFileCategory(i: number, category: any) {
    this.filesToUpload[i].documentTypeClassId = category;
  }

  uploadFiles(): Observable<any> {
    // convert files to needed strings manually as toString() method not implemented in ios safari
    this.forStudentId = +localStorage.getItem('forStudentId')
    const localStorageData = JSON.parse(localStorage.getItem('loginUserData'));
    const userRole = localStorageData.role;
    const files = this.filesToUpload.map((f) => {
      const fileBytes: Uint8Array = f.file;
      const file = [];
      for (let i = 0; i < fileBytes.byteLength; i++) {
        file.push(fileBytes[i] + '');
      }
      f.file = file.join(',');
      return f;
    });
    
    const studentDocument = this._router.url === '/coach/assignment' || this._router.url === '/coach/essays'  || this._router.url === '/coach/coachStudentDetail' ? 1 : 0;
    return this._commonRequestResponseService.postWithHeader('shared/attachments/multiple', { attachmentList: files, fromUserId: '-1', forStudent: this.forStudentId ? this.forStudentId : this.currentStudentUserId, partnerId: this.messageData.partnerId, uploadInStudentDocuments: studentDocument });
  }

  sendMessage(form: NgForm) {
    if (this.filesToUpload.length) {
      this.uploadFiles()
        .subscribe(
          (fileUploadResult: any) => {
            if (fileUploadResult && fileUploadResult.attachmentIds && fileUploadResult.attachmentIds.length) {
              this.attachmentIdArray = fileUploadResult.attachmentIds;
              this.onSendMessage(form);
              this._commonDataSharedService.updateStudentDocuments.next();
            }
          },
          () => {
            this.notificationService.show('error', 'Error while uploading files');
          });
      return;
    }

    this.onSendMessage(form);

  }

  ngOnDestroy() {
    this.beforeUnloadUnsubscribe();
    this.rerenderGridSubscription.unsubscribe();
  }
}
